import { Children, Fragment, isValidElement, type ReactElement, type ReactNode } from "react";

function columnChildren(children: ReactNode): ReactElement[] {
  const items: ReactElement[] = [];

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;

    if (child.type === Fragment) {
      items.push(...columnChildren(child.props.children));
      return;
    }

    items.push(child);
  });

  return items;
}

/**
 * Vertical stack for multiple detail cards within one column.
 */
export default function DetailsCardColumn({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col gap-y-10">
      {columnChildren(children).map((child, index) => (
        <div key={index} className="min-w-0">
          {child}
        </div>
      ))}
    </div>
  );
}
